import { injectable, injectFromBase } from 'inversify'
import { DomainSettings } from '@/decorators/domainDecorators'
import DomainBaseService from '@/services/domain/domainBaseService'
import UnauthenticatedCountry from '@/data/models/domain/UnauthenticatedCountry'
import type UnauthenticatedCountryRepository from '@/data/repositories/domain/unauthenticatedCountryRepository'

@DomainSettings({
  model: UnauthenticatedCountry,
})
@injectable()
@injectFromBase()
export default class UnauthenticatedCountryService extends DomainBaseService<UnauthenticatedCountryRepository> {
  public async detectCountry(): Promise<UnauthenticatedCountry> {
    return this.getDomainRepository().detectCountry()
  }

  public getCountry(): UnauthenticatedCountry | null {
    return this.getDomainRepository().getCountry()
  }

  public async loadCountry(): Promise<UnauthenticatedCountry> {
    const country: UnauthenticatedCountry | null = this.getCountry()
    if (country) {
      return country
    }

    return this.detectCountry()
  }
}
